import type { FooterColLinks } from '../types/footer';
import { ReferenceType } from '../types/fsReference';

export const getItemLinkRefUrl = (
  item: FooterColLinks['st_elements']['value'][number]['st_link_list_items']['value'][number],
) => {
  if (item.lt_link_type === 'external') {
    return item.lt_link_url;
  }

  switch (item.lt_link_ref?.fsType) {
    case ReferenceType.Media:
      return item.lt_link_ref.url;
    case ReferenceType.GCAPage:
    case ReferenceType.PageRef:
      return item.lt_link_ref.route;

    default:
      return '#';
  }
};
